<script>
	module.exports = {
		props: ['product', 'subArticle', 'assignmentId'],
		computed: {
			selectedProduct: function () {
				return this.subArticle || this.product;
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';

	.main-content.wrapper.ebook {
		max-width: $bp-width-lg;
	}
</style>
<template>
	<div class="main-content wrapper ebook">
		<div class="main-content-article rte">
			<article-ebook
				:article="selectedProduct"
				:assignment-id="assignmentId"></article-ebook>
		</div>
	</div>
</template>
